import * as ss from 'superstruct';
import { Id } from '../types';
import {
  ConnectedAccountResource,
  ConnectedAccountStatus,
  ConnectedAccountTypeInfo,
} from './connected-account.resource';

/** Vendors whose own API keys input streams read through. */
export const IntegrationConnectionTypeList = ['dialpad', 'leap'] as const;

export const IntegrationConnectionType = ss.enums(
  IntegrationConnectionTypeList,
);

export type IntegrationConnectionType =
  (typeof IntegrationConnectionTypeList)[number];

export const IntegrationConnectionTypes: Record<
  IntegrationConnectionType,
  ConnectedAccountTypeInfo
> = {
  dialpad: { label: 'Dialpad', identity: 'api-key' },
  leap: { label: 'Leap', identity: 'api-key' },
};

/**
 * A vendor account an Arrows Up account's streams read through, by its API
 * key. Two Arrows Up accounts sharing a vendor account each have their own
 * connection. `name` is what people pick it by, unique per type.
 */
export const IntegrationConnectionResource = ss.assign(
  ConnectedAccountResource,
  ss.type({
    type: IntegrationConnectionType,
    name: ss.string(),
  }),
);

export type IntegrationConnectionResource = ss.Infer<
  typeof IntegrationConnectionResource
>;

/** A stream's connection: all of it a stream shows, and only `id` to write. */
export const IntegrationConnectionRef = ss.type({
  id: Id,
  type: ss.optional(IntegrationConnectionType),
  name: ss.optional(ss.string()),
  status: ss.optional(ConnectedAccountStatus),
});

export type IntegrationConnectionRef = ss.Infer<
  typeof IntegrationConnectionRef
>;
